import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PolicyListItem } from '../../../common/PolicyListItem';

import styles from './PolicySelector.module.css';

const PoliciesSection = ({
  disabled = false,
  onPolicyItemPress = () => { },
  policies = [],
  sectionTitle = '',
  selectedPolicy = null,
}) => (
  <section className={styles.sectionContainer}>
    <h1 className={styles.sectionTitle}>
      {sectionTitle}
    </h1>

    <ul className={styles.listContainer}>
      {policies.map((policy) => (
        <PolicyListItem
          key={policy.PolicyNumber}
          disabled={disabled}
          endsOn={policy.ExpirationDate}
          marketingChannel={policy.PolicyMarketingChannelId}
          onClick={onPolicyItemPress(policy)}
          policyNumber={policy.PolicyNumber}
          selected={selectedPolicy?.PolicyId === policy.PolicyId}
          startsOn={policy.EffectiveDate}
          status={policy.PolicyStatus}
          statusId={policy.Status}
        />
      ))}
    </ul>
  </section>
);

const PolicySelector = ({
  onPolicyItemPress = () => { },
  onContactSupportClick = () => { },
  petPoliciesDisabled = [],
  petPoliciesEnabled = [],
  selectedPolicy = null,
}) => {
  const { t } = useTranslation('fileClaimbot');

  if (petPoliciesDisabled.length === 0) {
    // only enabled policies so no header is shown (just as regular)
    return (
      <PoliciesSection
        onPolicyItemPress={onPolicyItemPress}
        policies={petPoliciesEnabled}
        selectedPolicy={selectedPolicy}
      />
    );
  }

  return (
    <div className={styles.mainContainer}>
      <PoliciesSection
        disabled
        onPolicyItemPress={onPolicyItemPress}
        policies={petPoliciesDisabled}
        sectionTitle={(
          <Trans
            components={{
              button: (
                <button
                  className={styles.contactSupportButton}
                  onClick={onContactSupportClick}
                  type="button"
                />
              ),
            }}
            i18nKey="policySelector.claimDisabledHeader"
            t={t}
          />
        )}
        selectedPolicy={selectedPolicy}
      />

      <PoliciesSection
        onPolicyItemPress={onPolicyItemPress}
        policies={petPoliciesEnabled}
        sectionTitle={t('policySelector.claimEnabledHeader')}
        selectedPolicy={selectedPolicy}
      />
    </div>
  );
};

export { PolicySelector };
